import React from "react";
import { ArrowRight } from "lucide-react";
import { bestSellers } from "../mock";
import ProductCard from "./ProductCard";

export default function BestSellersSection() {
  return (
    <section id="tshirts" className="bg-[color:var(--dms-cream)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
        <p className="kicker">Most loved</p>
        <h2 className="font-serif text-4xl md:text-5xl text-[color:var(--dms-navy)] mt-4">Best-selling shirts</h2>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
        <p className="mt-6 text-[color:var(--dms-navy)]/70 max-w-xl mx-auto">The designs people keep coming back for — in tees and long sleeves.</p>
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {bestSellers.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
      <div className="text-center mt-12">
        <a href="#tshirts" className="btn-ghost-navy">Browse every shirt <ArrowRight className="w-4 h-4" /></a>
      </div>
    </section>
  );
}
